import { useNavigation } from "@react-navigation/native";
import { Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import ScreenNames from "../../constants/routeNames";
import { getNextScreen } from "../../navigation/simpleOnboardingFlow";
import { selectHealthGoals, setHealthGoals } from "../../slices/simpleOnboardingSlice";
import SelectionScreen, { type Option } from "../New_DIY_form/SelectionScreen";

const SimpleOnboardingHealthGoalsScreen = (): JSX.Element => {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const selectedHealthGoals = useSelector(selectHealthGoals);

  const options: Option[] = [
    {
      value: "LOSE_WEIGHT",
      label: t("simple_onboarding.health_goals.LOSE_WEIGHT"),
      description: "",
      icon: "scale-bathroom",
      iconType: "material-community",
    },
    {
      value: "BALANCE_BLOOD_SUGAR",
      label: t("simple_onboarding.health_goals.BALANCE_BLOOD_SUGAR"),
      description: "",
      icon: "Heart",
      iconType: "lucide",
    },
    {
      value: "GUT_HEALTH",
      label: t("simple_onboarding.health_goals.GUT_HEALTH"),
      description: "",
      icon: "Sprout",
      iconType: "lucide",
    },
    {
      value: "HORMONAL_BALANCE",
      label: t("simple_onboarding.health_goals.HORMONAL_BALANCE"),
      description: "",
      icon: "Users",
      iconType: "lucide",
    },
    {
      value: "IMPROVE_ENERGY",
      label: t("simple_onboarding.health_goals.IMPROVE_ENERGY"),
      description: "",
      icon: "Zap",
      iconType: "lucide",
    },
    {
      value: "REDUCE_INFLAMMATION",
      label: t("simple_onboarding.health_goals.REDUCE_INFLAMMATION"),
      description: "",
      icon: "fire",
      iconType: "material-community",
    },
    {
      value: "LOWER_STRESS",
      label: t("simple_onboarding.health_goals.LOWER_STRESS"),
      description: "",
      icon: "Shield",
      iconType: "lucide",
    },
  ];

  return (
    <Formik
      initialValues={{ healthGoals: selectedHealthGoals || [] }}
      onSubmit={(values) => {
        dispatch(setHealthGoals(values.healthGoals));
        const nextScreen = getNextScreen(ScreenNames.SimpleOnboarding_1b_HealthGoals);
        if (nextScreen) {
          navigation.navigate(nextScreen as never);
        }
      }}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <SelectionScreen
          title={t("simple_onboarding.health_goals.title")}
          subtitle={t("simple_onboarding.health_goals.subtitle")}
          options={options}
          multipleSelection={true}
          selectedOptions={values.healthGoals}
          setSelectedOptions={(goals) => setFieldValue("healthGoals", goals)}
          onPressNext={handleSubmit}
          onPressBack={() => navigation.goBack()}
          nextButtonDisabled={values.healthGoals.length === 0}
          nextButtonTestIdPostfix="health-goals"
        />
      )}
    </Formik>
  );
};

export default SimpleOnboardingHealthGoalsScreen;
